import { FC, useContext, useEffect, useState } from 'react'

import { List } from 'antd'

import { useTracksQuery } from '../../graphql'

import { Context } from './Context'
import { TrackCard } from './TrackCard'

const TrackList: FC<{ active: boolean }> = ({ active }) => {
  const { country, track, checked, setData, setChecked } = useContext(Context)
  const { data, loading } = useTracksQuery({ variables: { filters: { active: { eq: active } } } })
  const [dataSource, setDataSource] = useState(data?.tracks)

  useEffect(() => {
    if (country || track) {
      if (country) {
        setDataSource((prevState) => (track ? prevState : data?.tracks)?.filter((it) => it?.country === country))
      }
      if (track) {
        setDataSource((prevState) =>
          (country ? prevState : data?.tracks)?.filter((it) => it?.name?.toLowerCase().includes(track.toLowerCase())),
        )
      }
    } else {
      setDataSource(data?.tracks)
    }
  }, [track, country, data])

  return (
    <List
      loading={loading}
      grid={{ gutter: 16, xs: 1, sm: 1, md: 2, lg: 2, xl: 3, xxl: 3 }}
      dataSource={dataSource?.slice().sort((a, b) => (b?.results.length ?? 0) - (a?.results.length ?? 0))}
      renderItem={(it) =>
        it && (
          <List.Item>
            <TrackCard
              selected={checked}
              onSelect={(checked) => {
                setChecked(checked)
                setData((prevState) => prevState.concat(it))
              }}
              {...it}
            />
          </List.Item>
        )
      }
    />
  )
}

export { TrackList }
